  // 時クラス追加
  $("*[class$='-child']").prev().addClass('block-child-prev');
  $("*[class^='page-block-'].bg-pink").prev().addClass('bg-pink-prev');
  $("*[class^='page-block-']").has('.button-search-list-area').addClass('search-list-area-include');
  $("*[class^='page-block-'] .headingThree01").prev().not("h2").addClass('headingThree01-prev');
  $("*[class^='page-block-'] .headingTwo02").prev().not("h2").not("figure").addClass('headingTwo02-prev');
  $("*[class^='page-block-'] .headingFour01").prev().not("h3").not("figure").addClass('headingFour01-prev');